<template>
  <div class="publicBox">
    <main class="publicBox_main">
      <div
        class="main_itemTop"
        style="flex-direction: column;
         align-items: baseline;"
      >
        <div
          style="width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;"
        >
          <div class="itemTop_left">
            <h3 class="left_title">投放设置</h3>
          </div>

          <div class="itemTop_right" @click="isOpen = !isOpen">
            <div class="add">
              <i class="el-icon-goods" />
              <span class="text">添加商品</span>
            </div>
            <span class="text">{{ isOpen ? '收起' : '展开' }}</span>
            <i :class="{'el-icon-arrow-down':isOpen, 'el-icon-arrow-up':!isOpen }" />
          </div>
        </div>

        <div v-if="!isOpen" class="open">
          <div class="open_item">
            <span class="name">推广目标</span>
            <span class="value">{{ paln.tgTarget === 'videoNumber' ? '视频号' : '公众号' }}</span>
          </div>
          <div class="open_item">
            <span class="name">日预算</span>
            <span class="value">{{ paln.dailyBudget ? paln.dailyBudget : '不限' }}</span>
          </div>
        </div>
      </div>

      <div class="main_itemTips">
        <div class="itemTips_left">
          <i class="left_icon">
            <svg class="mr-8 adui-icon-base" width="20" height="20" viewBox="0 0 18 18" fill="var(--transparent-gray-900)" data-interactive="false" data-icon="radar-outlined"><path d="M9 1C10.3912 1 11.6994 1.35509 12.839 1.97958L11.7217 3.09552C10.8937 2.71325 9.97178 2.5 9 2.5C5.41015 2.5 2.5 5.41015 2.5 9C2.5 12.5899 5.41015 15.5 9 15.5C12.5899 15.5 15.5 12.5899 15.5 9C15.5 8.02822 15.2867 7.10625 14.9045 6.27834L16.0204 5.16103C16.6449 6.30062 17 7.60884 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1ZM9 4C9.54724 4 10.074 4.08792 10.5668 4.25039L9.30457 5.51307C9.2042 5.50442 9.10262 5.5 9 5.5C7.067 5.5 5.5 7.067 5.5 9C5.5 10.933 7.067 12.5 9 12.5C10.933 12.5 12.5 10.933 12.5 9C12.5 8.89841 12.4957 8.79782 12.4872 8.69843L13.7499 7.43423C13.9122 7.92676 14 8.45313 14 9C14 11.7614 11.7614 14 9 14C6.23858 14 4 11.7614 4 9C4 6.23858 6.23858 4 9 4ZM15 3C15.2929 3.29289 15.2929 3.76777 15 4.06066L10.4495 8.61246C10.4824 8.73608 10.5 8.86599 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.13401 7.5 9.26392 7.51757 9.38754 7.55054L13.9393 3C14.2322 2.70711 14.7071 2.70711 15 3Z" fill-rule="evenodd" /></svg>
          </i>
          <div class="left_tips">
            <span class="title">推广类型</span>
          </div>
        </div>
      </div>

      <div class="main_xuanz">
        <div class="xuanz_left">
          <span class="title">推广类型</span>
          <div class="xuanz_main">
            <el-radio v-model="delivery_settings.promotionType" label="dynamic">视频号动态</el-radio>
            <el-radio v-model="delivery_settings.promotionType" label="liveBroadcast">视频号直播</el-radio>
          </div>
        </div>
      </div>

      <div class="main_itemTips">
        <div class="itemTips_left">
          <i class="left_icon">
            <svg class="mr-8 adui-icon-base" width="20" height="20" viewBox="0 0 18 18" fill="var(--transparent-gray-900)" data-interactive="false" data-icon="location-outlined"><path d="M9.39066 16.5152C9.36746 16.5442 9.34111 16.5706 9.31207 16.5938C9.09631 16.7661 8.78167 16.7309 8.60931 16.5152C5.20309 12.2512 3.5 9.12116 3.5 7.125C3.5 4.0184 5.96243 1.5 9 1.5C12.0376 1.5 14.5 4.0184 14.5 7.125C14.5 9.12116 12.7969 12.2512 9.39066 16.5152ZM8.96 14.5C11.6 10.9314 12.92 8.41803 12.92 6.96C12.92 4.77295 11.147 3 8.96 3C6.77295 3 5 4.77295 5 6.96C5 8.41803 6.32 10.9314 8.96 14.5ZM9 9.25C7.75736 9.25 6.75 8.24264 6.75 7C6.75 5.75736 7.75736 4.75 9 4.75C10.2426 4.75 11.25 5.75736 11.25 7C11.25 8.24264 10.2426 9.25 9 9.25ZM9 8C9.55228 8 10 7.55228 10 7C10 6.44772 9.55228 6 9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8Z" fill-rule="evenodd" /></svg>
          </i>
          <div class="left_tips">
            <span class="title">投放位置</span>
            <span class="tips">选择广告展现的位置</span>
          </div>
        </div>
      </div>

      <div class="main_liulang">
        <div class="liulan_left">
          <span class="title">流量位</span>
          <div class="left_main">
            <div class="item" :class="{active:delivery_settings.flowBit === 'wechatMoments'}">
              <i class="icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" fill="white" /><path d="M15.6299 27.2904L20.1388 22.7946V31.575C18.5104 30.8277 17.384 29.7596 16.6602 28.8683C16.2881 28.41 16.0228 27.9988 15.8507 27.7028C15.7647 27.5547 15.702 27.4356 15.661 27.3538C15.6487 27.3292 15.6383 27.308 15.6299 27.2904Z" fill="#E0E0E0" /><path d="M15.0675 20.1049L21.4162 20.1124L15.1852 26.3213C14.5639 24.6451 14.5327 23.0941 14.661 21.9518C14.7269 21.3645 14.835 20.8857 14.9264 20.5543C14.9721 20.3887 15.0136 20.2599 15.0435 20.173C15.0526 20.1463 15.0607 20.1236 15.0675 20.1049Z" fill="#D6D6D6" /><path d="M21.1058 31.9157L21.1134 25.6151L27.3404 31.8241C25.6596 32.4426 24.1044 32.4674 22.9589 32.3333C22.3698 32.2644 21.8897 32.1535 21.5573 32.06C21.3911 32.0133 21.262 31.9709 21.1748 31.9404C21.1477 31.9309 21.1247 31.9226 21.1058 31.9157Z" fill="#D6D6D6" /><path d="M28.1862 31.3561L23.7703 26.923H32.5831C31.8323 28.5443 30.7376 29.6513 29.8197 30.3574C29.3477 30.7204 28.9229 30.9771 28.6167 31.1428C28.4636 31.2256 28.3402 31.2856 28.2554 31.3248C28.2283 31.3374 28.2051 31.3478 28.1862 31.3561Z" fill="#D6D6D6" /><path d="M32.8885 25.9582L26.6024 25.9507L32.8333 19.7418C33.4536 21.4175 33.4694 22.9679 33.3258 24.11C33.252 24.6972 33.136 25.1759 33.0387 25.5072C32.9901 25.6728 32.9462 25.8016 32.9145 25.8885C32.9046 25.916 32.8958 25.9393 32.8885 25.9582Z" fill="#BFBFBF" /><path d="M24.2458 19.1402L19.7066 14.6449L19.6784 14.6586L19.6437 14.6759C19.5624 14.7168 19.4439 14.7793 19.2967 14.865C19.0023 15.0366 18.5933 15.3012 18.137 15.6722C17.2496 16.3937 16.1849 17.5167 15.4353 19.1402H24.2458Z" fill="#BFBFBF" /><path d="M26.9765 14.0837L26.9689 20.3842L20.7419 14.1753C22.4227 13.5568 23.9779 13.5319 25.1234 13.666C25.7125 13.735 26.1927 13.8459 26.525 13.9394C26.6912 13.9861 26.8203 14.0284 26.9075 14.059C26.9346 14.0684 26.9576 14.0768 26.9765 14.0837Z" fill="#BFBFBF" /><path d="M27.9436 23.2709L32.3902 18.898C32.3818 18.879 32.3714 18.8557 32.3588 18.8284C32.3195 18.7432 32.2593 18.6191 32.1762 18.4652C32.0101 18.1573 31.7527 17.7304 31.3885 17.2564C30.6803 16.3347 29.57 15.2367 27.9436 14.4883V23.2709Z" fill="#BFBFBF" /><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4C10.7909 4 9 5.79086 9 8V40C9 42.2091 10.7909 44 13 44H35C37.2091 44 39 42.2091 39 40V8C39 5.79086 37.2091 4 35 4H13ZM35 6H13C11.8954 6 11 6.89543 11 8V40C11 41.1046 11.8954 42 13 42H35C36.1046 42 37 41.1046 37 40V8C37 6.89543 36.1046 6 35 6Z" fill="#BFBFBF" /></svg>
              </i>
              <div class="item_main">
                <span class="title">朋友圈信息流</span>
                <span class="tips">向浏览微信朋友圈的用户，精准展现广告</span>
              </div>
              <i class="myIn">√</i>
            </div>

            <div class="item" :class="{active:delivery_settings.flowBit === 'publicPlatform'}">
              <i class="icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 24.5C15 24.2239 15.2239 24 15.5 24H24.5C24.7761 24 25 24.2239 25 24.5V25.5C25 25.7761 24.7761 26 24.5 26H15.5C15.2239 26 15 25.7761 15 25.5V24.5Z" fill="#E0E0E0" /><path d="M15 33.5C15 33.2239 15.2239 33 15.5 33H32.5C32.7761 33 33 33.2239 33 33.5V36.5C33 36.7761 32.7761 37 32.5 37H15.5C15.2239 37 15 36.7761 15 36.5V33.5Z" fill="#E0E0E0" /><path d="M15.5 28C15.2239 28 15 28.2239 15 28.5V29.5C15 29.7761 15.2239 30 15.5 30H32.5C32.7761 30 33 29.7761 33 29.5V28.5C33 28.2239 32.7761 28 32.5 28H15.5Z" fill="#E0E0E0" /><path d="M15.5 20C15.2239 20 15 20.2239 15 20.5V21.5C15 21.7761 15.2239 22 15.5 22H24.5C24.7761 22 25 21.7761 25 21.5V20.5C25 20.2239 24.7761 20 24.5 20H15.5Z" fill="#D6D6D6" /><path d="M27.5 20C27.2239 20 27 20.2239 27 20.5V25.5C27 25.7761 27.2239 26 27.5 26H32.5C32.7761 26 33 25.7761 33 25.5V20.5C33 20.2239 32.7761 20 32.5 20H27.5Z" fill="#D6D6D6" /><path d="M16 10C15.4477 10 15 10.4477 15 11V16C15 16.5523 15.4477 17 16 17H32C32.5523 17 33 16.5523 33 16V11C33 10.4477 32.5523 10 32 10H16Z" fill="#BFBFBF" /><path fill-rule="evenodd" clip-rule="evenodd" d="M9 8C9 5.79086 10.7909 4 13 4H35C37.2091 4 39 5.79086 39 8V40C39 42.2091 37.2091 44 35 44H13C10.7909 44 9 42.2091 9 40V8ZM13 6H35C36.1046 6 37 6.89543 37 8V40C37 41.1046 36.1046 42 35 42H13C11.8954 42 11 41.1046 11 40V8C11 6.89543 11.8954 6 13 6Z" fill="#BFBFBF" /></svg>
              </i>
              <div class="item_main">
                <span class="title">公众平台流量</span>
                <span class="tips">向公众号、小程序、小游戏等微信公众平台流量场景下的用户展示广告</span>
              </div>

              <i class="myIn">√</i>
            </div>
          </div>
        </div>
      </div>

      <div class="main_directional">
        <div class="directional_item">
          <span class="item_title">广告位定向</span>
          <div class="item_main">
            <span class="tips">让广告在指定广告位中展示</span>
            <div class="main">
              <el-switch
                v-model="delivery_settings.directional"
                active-color="#13ce66"
                inactive-color="#ff4949"
              />
              <span class="text">已启用</span>
            </div>

          </div>
        </div>
        <div class="directional_item">
          <span class="item_title">广告位</span>
          <div class="item_main">
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="公众号文章底部" />
              <el-checkbox label="公众号文章中部" />
              <el-checkbox label="订阅号消息列表" />
              <el-checkbox label="微信支付订单详情页" />
              <el-checkbox label="小程序激励式广告" />
              <el-checkbox label="小程序插屏广告" />
            </el-checkbox-group>
          </div>
        </div>
      </div>

      <div class="main_itemTips">
        <div class="itemTips_left">
          <i class="left_icon">
            <svg class="mr-8 adui-icon-base" width="20" height="20" viewBox="0 0 18 18" fill="var(--transparent-gray-900)" data-interactive="false" data-icon="location-outlined"><path d="M9.39066 16.5152C9.36746 16.5442 9.34111 16.5706 9.31207 16.5938C9.09631 16.7661 8.78167 16.7309 8.60931 16.5152C5.20309 12.2512 3.5 9.12116 3.5 7.125C3.5 4.0184 5.96243 1.5 9 1.5C12.0376 1.5 14.5 4.0184 14.5 7.125C14.5 9.12116 12.7969 12.2512 9.39066 16.5152ZM8.96 14.5C11.6 10.9314 12.92 8.41803 12.92 6.96C12.92 4.77295 11.147 3 8.96 3C6.77295 3 5 4.77295 5 6.96C5 8.41803 6.32 10.9314 8.96 14.5ZM9 9.25C7.75736 9.25 6.75 8.24264 6.75 7C6.75 5.75736 7.75736 4.75 9 4.75C10.2426 4.75 11.25 5.75736 11.25 7C11.25 8.24264 10.2426 9.25 9 9.25ZM9 8C9.55228 8 10 7.55228 10 7C10 6.44772 9.55228 6 9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8Z" fill-rule="evenodd" /></svg>
          </i>
          <div class="left_tips">
            <span class="title">推广商品</span>
          </div>
        </div>
      </div>

      <div class="main_shangpin">
        <div class="shangpin_item">
          <span class="item_title">商品库</span>
        </div>
        <div class="shangpin_item">
          <span class="item_title">商品</span>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    delivery_settings: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      isOpen: true,
      checked: '1',
      value: ''
    }
  },
  created() {
    console.log(this.delivery_settings)
  }
}
</script>

<style lang="less" scoped>
@import url('../../public.less');
.publicBox{
  .publicBox_main{
    .main_itemTop{
      .itemTop_left{
        .left_title{
          font-size: 19px;
          font-weight: bold;
        }
      }
      .itemTop_right{
        display: flex;
        .add{
            .text{

          }
        }
    }
    }

    .main_xuanz{
      padding: 32px 64px;
      border-bottom: 1px solid rgba(0,0,0,.06);
      .xuanz_left{
        display: flex;
        .title{
          display: inline-block;
          width: 92px;
          margin-right: 28px;
        }

        .xuanz_main{

        }
      }
    }

    .main_liulang{
       padding: 32px 64px;
       border-bottom: 1px solid rgba(0,0,0,.06);
      .liulan_left{
        display: flex;

        .title{
           display: inline-block;
           width: 92px;
           margin-right: 28px;
        }
        .left_main{
          display: flex;
          .item{
             padding: 10px;
             width: 500px;
             height: 72px;
             position: relative;
             border-radius: 6px;
             box-shadow: 0 0 0 1px #ebebeb;
             cursor: pointer;
             display: flex;
             margin: 0px 10px;

             &:not(.active):hover{
               box-shadow: 0 0 0 2px #ebebeb;
               .myIn{
                 display: flex;
               }
             }
             &.active{
               box-shadow: 0 0 0 2px #07c160;
                .myIn{
                  background-color: #07c160;
                }
                .item_main{
                  color: #07c160;
                }
                svg{
                  fill: #07c160;
                }
                path{
                  fill: #07c160;
                }
             }
             .icon{

             }

             .item_main{
               display: flex;
               flex-direction: column;
               justify-content: center;
               color: #BFBFBF;
               .title{
                  display: inline-block;
                  margin-bottom: 5px;
                  font-weight: bold;
               }
               .tips{

               }
             }

             .myIn{
               display: none;
               align-items: center;
               justify-content: center;
               width: 15px;
               height: 15px;
               border-radius: 100%;
               background-color: #BFBFBF;
               color: #fff;
               position: absolute;
               font-style: normal;
               top: 3px;
               right: 4px;
             }
          }
        }
      }
    }

    .main_directional{
      padding: 32px 64px;
      border-bottom: 1px solid rgba(0,0,0,.06);
          .directional_item{
            display: flex;
            .item_title{
              display: inline-block;
              width: 92px;
              margin-right: 28px;
            }

            .item_main{
               .tips{

               }
               .main{
                 margin-top: 10px;
                 display: flex;
                 align-items: center;
                 .text{
                   display: inline-block;
                   margin-left: 5px;
                 }
               }
            }

            &:not(:last-child){
              margin-bottom: 25px;
            }
          }
    }

    .main_shangpin{
      padding: 32px 64px;
      border-bottom: 1px solid rgba(0,0,0,.06);
        .shangpin_item{
          display: flex;
          .item_title{
              display: inline-block;
              width: 92px;
              margin-right: 28px;
          }

          &:not(:last-child){
              margin-bottom: 25px;
            }
        }
    }
  }
}
</style>
